import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Abandoned Carts list configuration
 * Unsubmitted orders from previous days (embedded in client view)
 */
export const clientEmbeddedAbandonedCartsList: ListBuilderList = {
	id: 'client-embedded-abandoned-carts',
	cacheTTL: 600000,
	name: 'Abandoned Carts',
	type: 'default',
	active: true,
	sortOrder: 5,
	requiredFeature: 'order-entry',
	columns: createStandardOrderClientEmbeddedColumns(),
	description: 'Unsubmitted orders from previous days that may need follow-up',
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderDateRange: {
			defaultValue: [
				{
					id: 'until-yesterday',
					label: 'Until Yesterday',
					data: {
						startDate: null,
						endDate: '{{DATE:-1d}}',
					},
				},
			],
		},
		orderStatus: {
			defaultValue: [{ id: '1', label: 'Unsubmitted' }],
		},
		orderOrigin: {
			defaultValue: [
				{ id: '1', label: 'CRM' },
				{ id: '3', label: 'E-Commerce' },
			],
		},
	},
};
